import { render } from "./LaptopIcon.vue?vue&type=template&id=b59778fe"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/LaptopIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b59778fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b59778fe', __exports__)) {
    api.reload('b59778fe', __exports__)
  }
  
  module.hot.accept("./LaptopIcon.vue?vue&type=template&id=b59778fe", () => {
    api.rerender('b59778fe', render)
  })

}


export default __exports__